import React from 'react';
export function MarqueeBar() {
  return <div className="fixed top-0 left-0 w-full bg-[#00A86B] text-white py-2 z-50 overflow-hidden marquee-container shadow-md" data-id="element-149">
      <div className="whitespace-nowrap flex" data-id="element-150">
        {/* Duplicate content for seamless looping */}
        <div className="animate-marquee flex-shrink-0 flex items-center" data-id="element-151">
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-152">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-153">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-154">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-155">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
        </div>
        <div className="animate-marquee flex-shrink-0 flex items-center" aria-hidden="true" data-id="element-156">
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-157">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-158">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-159">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
          <span className="font-heading font-bold text-sm md:text-base mx-4" data-id="element-160">
            🔥🔥 OFERTA SOLO POR HOY + BONUS GRATIS DE REGALO 🔥🔥
          </span>
        </div>
      </div>
    </div>;
}